import { ADMIN_CODE_IMPORT } from './index';
import { Action } from '../action';

export class AdminCodeImportInitAction implements Action {
	readonly type = ADMIN_CODE_IMPORT.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminCodeImportDestroyAction implements Action {
	readonly type = ADMIN_CODE_IMPORT.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminCodeImportReadFileAction implements Action {
	readonly type = ADMIN_CODE_IMPORT.READ_FILE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class AdminCodeImportReadFileSuccessAction implements Action {
	readonly type = ADMIN_CODE_IMPORT.READ_FILE_SUCCESS;
	constructor(
		public payload: any[],
		public correlationId?: number
	) {}
}

export class AdminCodeImportReadFileErrorAction implements Action {
	readonly type = ADMIN_CODE_IMPORT.READ_FILE_ERROR;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}
